export const initialAbility = [

];

export const _ = undefined;
